import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SLSFamiliaComercialClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/familia-comercial');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Familia Comercial');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/familia-comercial', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Familia Comercial');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/familia-comercial', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Familia Comercial');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/familia-comercial/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Familia Comercial');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/familia-comercial/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Familia Comercial');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/familia-comercial/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Familia Comercial');
    }
  }

  async getProdutosDestaque() {
    try {
      const { data } = await this.api.get('/familia-comercial/produtos-destaque');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os produtos em destaque');
    }
  }
}
